module.exports = __webpack_public_path__ + "static/media/logo-agep-white.5dc3c6a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/features/Layout/assets/img/logo-agep-white.png
// module id = 874
// module chunks = 0